<ion-item class="file-input">

  @if (file) {

    <ion-thumbnail slot="start" (click)="openFile()">

      @if (fileViewerManager.getFileType(file.url, file.extension) === 'image') {

        <img [src]="file.url || 'assets/img/empty-img/no_image.png'" alt="--"/>

      } @else {

        <yu-icon class="thumbnail-icon" [name]="fileViewerManager.getFileIcon(file.url, file.extension)"></yu-icon>

      }

    </ion-thumbnail>

  }

  @if (labelButton) {

    <yu-button
      expand="block"
      size="small"
      color="gradient"
      [disabled]="disabledButton"
      (yuClick)="clickButton.emit()"
    >
      {{ labelButton }}
    </yu-button>

  } @else if (labelFile) {

    <ion-label>{{ labelFile }}</ion-label>

  }

  @if (canRemove) {

    <ion-note
      slot="end"
      (click)="fileRemoved.emit()"
    >
      <yu-icon name="x-circle" color="error"></yu-icon>
    </ion-note>

  }

</ion-item>
